import { combineReducers } from '@reduxjs/toolkit';
import dialog from './dialogSlice';
import message from './messageSlice';
import loading from './loadingSlice';
import preview from './previewSlice';
import navbar from './navbarSlice';
import navigation from './navigationSlice';
import settings from './settingsSlice';
import header from './headerSlice';

const fuseReducers = combineReducers({
	navigation,
	settings,
	navbar,
	message,
	loading,
	preview,
	dialog,
	header
});

export default fuseReducers;
